import { useSellerPasswordReset } from '@/hooks/sellers/useGetSellers/useSellerPasswordReset';
import { useImmer } from 'use-immer';
import {
  initialRequestNewPasswordFormUi,
  RequestNewPasswordFormUi,
} from './RequestNewPasswordFormUi';

export function useRequestNewPasswordFormViewController() {
  const [uiState, setUiState] = useImmer<RequestNewPasswordFormUi>(
    initialRequestNewPasswordFormUi
  );
  const { resetPassword } = useSellerPasswordReset();

  const onEmailChanged = (email: string) =>
    setUiState((state) => {
      state.email = email;
      state.isDisabled = !email.trim();
    });

  const handleSubmit = () => {
    setUiState((draft) => {
      draft.isSending = true;
      draft.isDisabled = true;
    });

    resetPassword(
      { email: uiState.email },
      {
        onSuccess: () =>
          setUiState((draft) => {
            draft.isEmailSubmitted = true;
          }),
        onSettled: () =>
          setUiState((draft) => {
            draft.isSending = false;
            draft.isDisabled = false;
          }),
      }
    );
  };

  return {
    uiState,
    actions: { handleSubmit, onEmailChanged },
  };
}
